import React, { useState } from 'react'
import CustomerMain from './CustomerMain'
import './CustomerDownloadCenter.scss'

import DOTAPP_ICON from '../../assets/images/download-center/icon_dot_app.png'
import APP_STORE from '../../assets/images/download-center/icon_appstore.png'
import PALY_STORE from '../../assets/images/download-center/icon_playstore.png'
import ARROW from '../../assets/images/download-center/icon_right_arrow.png'

import * as utils from '../../utils'
import Spinner from 'components/common/Spinner'

const CustomerDownloadCenter = () => {
    const [loading, setLoading] = useState(false)
    const [buttonShow, setButtonShow] = useState({
        prm: {
            file1: false,
            file2: false,
            file3: false,
            file4: false,
            file5: false,
        },
        ect: {
            file1: false,
            file2: false,
            file3: false,
            file4: false,
        },
        gds: {
            file1: false,
            file2: false,
            file3: false,
            file4: false,
            file5: false,
        },
    })

    const onMouseover = (key1, key2) => {
        setButtonShow(prev => ({
            ...prev,
            [key1]: {
                ...prev[key1],
                [key2]: true,
            },
        }))
    }
    const onMouseLeave = (key1, key2) => {
        setButtonShow(prev => ({
            ...prev,
            [key1]: {
                ...prev[key1],
                [key2]: false,
            },
        }))
    }

    const handleDownloadFile = (fileName, newname) => {
        const fileUrl = `/file/${fileName}`
        const anchor = document.createElement('a')
        anchor.href = fileUrl
        anchor.download = newname.normalize('NFC')
        anchor.click()
    }

    const handleDownloadApk = async url => {
        try {
            setLoading(true)
            const response = await fetch(url, { mode: 'cors' })
            const blob = await response.blob()

            // 서버에서 Content-Disposition 헤더를 확인
            const contentDisposition = response.headers.get('content-disposition')

            let filename = 'download.apk' // 기본값 (백업용)

            //서버에서 파일명을 지정한 경우
            if (contentDisposition) {
                const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
                if (match && match[1]) {
                    filename = match[1].replace(/['"]/g, '') // 따옴표 제거
                }
            } else {
                // 헤더가 없으면 URL의 마지막 경로를 파일명으로 사용
                filename = url.split('/').pop() || filename
            }

            // 다운로드
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = filename
            link.click()

            // 메모리 해제
            window.URL.revokeObjectURL(link.href)
        } catch (e) {
        } finally {
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            {loading && <Spinner />}
            <CustomerMain />
            <div className="customer-center-body-wrap">
                <div className="customer-center-download-wrap-one">
                    <h2 className="customer-download-center-title">다운로드 센터</h2>
                    <p className="customer-download-center-sub-title">
                        차량의 사용설명서 및 각종 매뉴얼/설명자료를 다운로드 할 수 있습니다.
                    </p>
                </div>
                <div className="customer-center-download-wrap-two">
                    <ul className="customer-center-download-list">
                        <li>
                            <img src={DOTAPP_ICON} alt="닷앱" />
                            <p className="title">닷스테이션</p>
                            <p className="subtitle">
                                바이크 배터리 관리, 요금제 및 워런티 결제 관리가 가능한 고객전용 앱
                            </p>

                            <button
                                className="store-button"
                                onClick={() =>
                                    window.open(
                                        'https://apps.apple.com/kr/app/%EB%8B%B7%EC%8A%A4%ED%85%8C%EC%9D%B4%EC%85%98/id6446716586',
                                    )
                                }>
                                <img src={APP_STORE} alt="닷앱" className="apple_icon" />
                                <p className="store-name">APP Store</p>
                            </button>
                            <button
                                className="store-button"
                                onClick={() =>
                                    window.open(
                                        'https://play.google.com/store/apps/details?id=com.genstation.client&pcampaignid=web_share',
                                    )
                                }>
                                <img src={PALY_STORE} alt="닷앱" className="play_icon" />
                                <p className="store-name">Play Store</p>
                            </button>
                        </li>
                        <li>
                            <p className="title mb-16">고샵 PRM 프로그램</p>
                            <button
                                className="download-button"
                                onMouseOver={() => onMouseover('prm', 'file1')} //
                                onMouseLeave={() => onMouseLeave('prm', 'file1')} //
                            >
                                <p>PC 설치파일</p>
                                <div
                                    onClick={() => handleDownloadApk(`${utils.DOWNLOAD_URL}genprm.zip`)}
                                    className={`download-button-hover hover-blue ${
                                        buttonShow.prm.file1 ? 'show' : ''
                                    }`}>
                                    <p>파일 다운로드</p>
                                    <img src={ARROW} alt="닷앱" className="arrow_icon" />
                                </div>
                            </button>
                            <button
                                className="download-button"
                                onMouseOver={() => onMouseover('prm', 'file2')} //
                                onMouseLeave={() => onMouseLeave('prm', 'file2')} //
                            >
                                <p>사용자 매뉴얼</p>
                                <div
                                    onClick={() =>
                                        handleDownloadFile('prmUserManual.pdf', '닷스테이션 PRM 사용자 매뉴얼.pdf')
                                    }
                                    className={`download-button-hover ${buttonShow.prm.file2 ? 'show' : ''}`}>
                                    <p>PDF 다운로드</p>
                                    <img src={ARROW} alt="닷앱" className="arrow_icon" />
                                </div>
                            </button>
                            <button
                                className="download-button"
                                onMouseOver={() => onMouseover('prm', 'file3')} //
                                onMouseLeave={() => onMouseLeave('prm', 'file3')} //
                            >
                                <p>전자결제 사용자 매뉴얼</p>
                                <div
                                    onClick={() =>
                                        handleDownloadFile(
                                            'prmUserManual_PG.pdf',
                                            '닷스테이션 PRM 전자결제 사용자 매뉴얼.pdf',
                                        )
                                    }
                                    className={`download-button-hover ${buttonShow.prm.file3 ? 'show' : ''}`}>
                                    <p>PDF 다운로드</p>
                                    <img src={ARROW} alt="닷앱" className="arrow_icon" />
                                </div>
                            </button>
                            <button
                                className="download-button"
                                onMouseOver={() => onMouseover('prm', 'file4')} //
                                onMouseLeave={() => onMouseLeave('prm', 'file4')} //
                            >
                                <p>사용자 워런티 등록 매뉴얼</p>
                                <div
                                    onClick={() =>
                                        handleDownloadFile(
                                            'prmUserManualWarranty.pdf',
                                            '닷스테이션 PRM 워런티 등록 매뉴얼.pdf',
                                        )
                                    }
                                    className={`download-button-hover ${buttonShow.prm.file4 ? 'show' : ''}`}>
                                    <p>PDF 다운로드</p>
                                    <img src={ARROW} alt="닷앱" className="arrow_icon" />
                                </div>
                            </button>
                            <button
                                className="download-button"
                                onMouseOver={() => onMouseover('prm', 'file5')} //
                                onMouseLeave={() => onMouseLeave('prm', 'file5')} //
                            >
                                <p>사용자 매뉴얼 영상</p>
                                <div
                                    className={`download-button-hover ${buttonShow.prm.file5 ? 'show' : ''}`}
                                    onClick={() => window.open('https://www.youtube.com/watch?v=AfPqY1ueth8')}>
                                    <p>You Tube 이동</p>
                                    <img src={ARROW} alt="닷앱" className="arrow_icon" />
                                </div>
                            </button>
                        </li>
                        <li>
                            <p className="title mb-16">기타설치 프로그램</p>
                            <button
                                className="download-button"
                                onMouseOver={() => onMouseover('ect', 'file1')} //
                                onMouseLeave={() => onMouseLeave('ect', 'file1')} //
                            >
                                <p>재배포 패키지</p>
                                <div
                                    onClick={() => handleDownloadApk(`${utils.DOWNLOAD_URL}vc2008_redist_x86.exe`)}
                                    className={`download-button-hover hover-blue ${
                                        buttonShow.ect.file1 ? 'show' : ''
                                    }`}>
                                    <p>파일 다운로드</p>
                                    <img src={ARROW} alt="닷앱" className="arrow_icon" />
                                </div>
                            </button>
                            <button
                                className="download-button"
                                onMouseOver={() => onMouseover('ect', 'file2')} //
                                onMouseLeave={() => onMouseLeave('ect', 'file2')} //
                            >
                                <p>닷넷프레임워크 4.5.2(신버전)</p>
                                <div
                                    onClick={() => handleDownloadApk(`${utils.DOWNLOAD_URL}dotnetfw.exe`)}
                                    className={`download-button-hover hover-blue ${
                                        buttonShow.ect.file2 ? 'show' : ''
                                    }`}>
                                    <p>파일 다운로드</p>
                                    <img src={ARROW} alt="닷앱" className="arrow_icon" />
                                </div>
                            </button>
                            <button
                                className="download-button"
                                onMouseOver={() => onMouseover('ect', 'file3')} //
                                onMouseLeave={() => onMouseLeave('ect', 'file3')} //
                            >
                                <p>Windows Installer 4.5</p>
                                <div
                                    onClick={() =>
                                        handleDownloadApk(`${utils.DOWNLOAD_URL}WindowsXP-KB942288-v3-x86.exe`)
                                    }
                                    className={`download-button-hover hover-blue ${
                                        buttonShow.ect.file3 ? 'show' : ''
                                    }`}>
                                    <p>파일 다운로드</p>
                                    <img src={ARROW} alt="닷앱" className="arrow_icon" />
                                </div>
                            </button>
                            <button
                                className="download-button"
                                onMouseOver={() => onMouseover('ect', 'file4')} //
                                onMouseLeave={() => onMouseLeave('ect', 'file4')} //
                            >
                                <p>재배포 패키지 2012</p>
                                <div
                                    onClick={() => handleDownloadApk(`${utils.DOWNLOAD_URL}vc2012_redist_x86.exe`)}
                                    className={`download-button-hover hover-blue ${
                                        buttonShow.ect.file4 ? 'show' : ''
                                    }`}>
                                    <p>파일 다운로드</p>
                                    <img src={ARROW} alt="닷앱" className="arrow_icon" />
                                </div>
                            </button>
                        </li>
                        <li>
                            <p className="title mb-16">GDS</p>
                            <button
                                className="download-button"
                                onMouseOver={() => onMouseover('gds', 'file1')} //
                                onMouseLeave={() => onMouseLeave('gds', 'file1')} //
                            >
                                <p>GDS 설치파일</p>
                                <div
                                    onClick={() => handleDownloadApk(`${utils.DOWNLOAD_URL}GDSInstallerPackage.zip`)}
                                    className={`download-button-hover ${buttonShow.gds.file1 ? 'show' : ''}`}>
                                    <p>파일 다운로드</p>
                                    <img src={ARROW} alt="닷앱" className="arrow_icon" />
                                </div>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </React.Fragment>
    )
}

export default CustomerDownloadCenter
